/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/jsx-no-target-blank */
import React, { useState } from "react";
import { useQuery } from "@apollo/client";
import { Container } from "../../../globalstyled";
import { useAccess } from "../../../hooks/useAccess";
import AppLoader from "../../../components/loader";
import { ANALYTICS_DASHBOARD } from "../../../apolloClient/operation/querys/userQuery";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Box,
  Divider,
  Chip,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  IconButton,
  Button,
  TextField,
  CircularProgress,
  ClickAwayListener,
} from "@mui/material";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import { Bar, Doughnut, Line, Chart } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement,
  PointElement,
  LineElement,
  Tooltip,
  Legend
);

// --- Styles ---
const cardStyle: React.CSSProperties = {
  background: "#fff",
  borderRadius: 16,
  boxShadow: "0 2px 12px 0 rgba(31, 38, 135, 0.08)",
  padding: 24,
  border: "1px solid #f1f5f9",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
};

const dashboardContainerStyle: React.CSSProperties = {
  background: "#f6f8fa",
  minHeight: "100vh",
  padding: "32px 24px",
};

const filterBarStyle: React.CSSProperties = {
  ...cardStyle,
  marginBottom: 24,
  boxShadow: "0 2px 8px 0 rgba(31, 38, 135, 0.04)",
  padding: "8px 20px",
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  flexDirection: "row",
  gap: 8,
  minHeight: 56,
};

const filterControlStyle: React.CSSProperties = {
  minWidth: 120,
  marginRight: 0,
};

const metricTitleStyle: React.CSSProperties = {
  color: "#64748b",
  fontWeight: 500,
  fontSize: 14,
  marginBottom: 4,
};
const metricValueStyle: React.CSSProperties = {
  color: "#22223b",
  fontWeight: 700,
  fontSize: 28,
  marginBottom: 2,
};
const metricSubStyle: React.CSSProperties = {
  color: "#64748b",
  fontWeight: 400,
  fontSize: 13,
};
const statusLegendDot = (color: string) => ({
  display: "inline-block",
  width: 10,
  height: 10,
  borderRadius: "50%",
  background: color,
  marginRight: 8,
  verticalAlign: "middle",
});

// --- Centralized Static Data ---
// const STATUS_COLORS = ["#22c55e", "#334155", "#fbbf24", "#f87171", "#2563eb"];
// const staticStatusData = [
//   { label: "Project Setup", value: 120, color: "#22c55e" },
//   { label: "Project Planning", value: 95, color: "#334155" },
//   { label: "Ordering", value: 78, color: "#fbbf24" },
//   { label: "Construction", value: 152, color: "#f87171" },
//   { label: "Completion", value: 225, color: "#2563eb" },
// ];
// const statusDoughnutData = {
//   labels: staticStatusData.map((d) => d.label),
//   datasets: [
//     {
//       data: staticStatusData.map((d) => d.value),
//       backgroundColor: staticStatusData.map((d) => d.color),
//       borderWidth: 0,
//       cutout: "80%",
//     },
//   ],
// };
// const statusTotal = staticStatusData.reduce((acc, d) => acc + d.value, 0);

const dashboardData = {
  filters: {
    dateRanges: [
      { label: "Last 7 days", value: "7d" },
      { label: "Last 30 days", value: "30d" },
      { label: "This Month", value: "month" },
      { label: "This Year", value: "year" },
      { label: "Custom", value: "custom" },
    ],
  },
  // leadsByTime: {
  //   total: 7522,
  //   chart: {
  //     labels: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
  //     datasets: [
  //       {
  //         label: "Leads",
  //         data: [1200, 1100, 900, 1300, 1000, 1100, 922],
  //         borderColor: "#2563eb",
  //         backgroundColor: "rgba(37,99,235,0.1)",
  //         fill: true,
  //         tension: 0.4,
  //       },
  //     ],
  //   },
  // },
  // revenueConstruction: {
  //   total: 228890,
  //   change: 4.2,
  //   sparkline: [20000, 22000, 21000, 23000, 24000, 25000, 22889],
  // },
  // revenueCompleted: {
  //   total: 158700,
  //   change: 5.1,
  //   sparkline: [15000, 15500, 16000, 15800, 15900, 15870],
  // },
  // amountPaid: {
  //   total: 90000,
  //   percent: 56.7,
  //   chart: {
  //     labels: ["Paid", "Unpaid"],
  //     datasets: [
  //       {
  //         data: [90000, 68590],
  //         backgroundColor: ["#2563eb", "#fbbf24"],
  //         borderWidth: 0,
  //       },
  //     ],
  //   },
  // },
  // completedProjects: {
  //   total: 225,
  //   chart: {
  //     labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul"],
  //     datasets: [
  //       {
  //         label: "Completed",
  //         data: [20, 25, 30, 28, 35, 40, 47],
  //         backgroundColor: "#22c55e",
  //         borderRadius: 6,
  //       },
  //     ],
  //   },
  // },
  // projectsByRep: {
  //   reps: [
  //     { name: "Alice", count: 80 },
  //     { name: "Bob", count: 65 },
  //     { name: "Charlie", count: 40 },
  //     { name: "David", count: 30 },
  //   ],
  //   chart: {
  //     labels: ["Alice", "Bob", "Charlie", "David"],
  //     datasets: [
  //       {
  //         label: "Projects",
  //         data: [80, 65, 40, 30],
  //         backgroundColor: "#2563eb",
  //       },
  //     ],
  //   },
  // },
};

// Add static data for active users and revenue for chart
// const leadsVsUsersVsRevenueChart = {
//   labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
//   datasets: [
//     {
//       label: "Leads",
//       data: [1200, 1100, 900, 1300, 1000, 1100, 922, 950, 1050, 1150, 1250, 1300],
//       borderColor: "#2563eb",
//       backgroundColor: "rgba(37,99,235,0.1)",
//       fill: false,
//       tension: 0.4,
//       pointRadius: 2,
//       borderWidth: 2,
//     },
//     {
//       label: "Active Users",
//       data: [800, 850, 780, 900, 870, 920, 890, 950, 1000, 980, 1020, 1100],
//       borderColor: "#22c55e",
//       backgroundColor: "rgba(34,197,94,0.08)",
//       fill: false,
//       tension: 0.4,
//       pointRadius: 2,
//       borderWidth: 2,
//     },
//     {
//       label: "Revenue",
//       data: [20000, 22000, 21000, 23000, 24000, 25000, 22889, 26000, 27000, 28000, 29000, 30000],
//       borderColor: "#fbbf24",
//       backgroundColor: "rgba(251,191,36,0.08)",
//       fill: false,
//       tension: 0.4,
//       pointRadius: 2,
//       borderWidth: 2,
//       yAxisID: "y1",
//     },
//   ],
// };

// --- Dashboard Top Metrics (remove Working Hours) ---
// const dashboardTopMetrics = [
//   { label: "Number of Projects", value: 9851, color: "#22223b" },
//   { label: "Active Projects", value: 1026, color: "#22c55e" },
//   { label: "Revenue", value: "$228.89k", color: "#fbbf24" },
// ];

// const projectsChartData = {
//   labels: [
//     "Jan",
//     "Feb",
//     "Mar",
//     "Apr",
//     "May",
//     "Jun",
//     "Jul",
//     "Aug",
//     "Sep",
//     "Oct",
//     "Nov",
//     "Dec",
//   ],
//   datasets: [
//     {
//       type: "bar" as const,
//       label: "Number of Projects",
//       data: [35, 65, 40, 55, 60, 70, 80, 45, 90, 60, 75, 68],
//       backgroundColor: "#22223b",
//       borderRadius: 6,
//       barThickness: 18,
//       yAxisID: "y",
//     },
//     {
//       type: "bar" as const,
//       label: "Active Projects",
//       data: [12, 18, 10, 15, 14, 20, 22, 13, 25, 18, 21, 19],
//       backgroundColor: "#22c55e",
//       borderRadius: 6,
//       barThickness: 18,
//       yAxisID: "y",
//     },
//     {
//       type: "line" as const,
//       label: "Revenue",
//       data: [
//         98580, 98580, 90000, 95000, 98000, 100000, 110000, 90000, 115000, 98000,
//         105000, 102000,
//       ],
//       borderColor: "#fbbf24",
//       backgroundColor: "rgba(251,191,36,0.08)",
//       fill: true,
//       tension: 0.4,
//       pointRadius: 3,
//       borderWidth: 2,
//       yAxisID: "y1",
//     },
//   ],
// };

// --- Helper Functions ---
const formatDateToMDY = (date: Date): string => {
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  const year = date.getFullYear();
  return `${month}/${day}/${year}`;
};

const getDateRangeForFilter = (filterValue: string, customDates?: [Date | null, Date | null]): { startDate: string; endDate: string } => {
  const today = new Date();
  const endDate = new Date(today);
  let startDate = new Date(today);

  switch (filterValue) {
    case '7d':
      startDate.setDate(today.getDate() - 7);
      break;
    case '30d':
      startDate.setDate(today.getDate() - 30);
      break;
    case 'month':
      startDate = new Date(today.getFullYear(), today.getMonth(), 1);
      break;
    case 'year':
      startDate = new Date(today.getFullYear(), 0, 1); // January 1st of current year
      break;
    case 'custom':
      if (customDates?.[0] && customDates?.[1]) {
        return {
          startDate: formatDateToMDY(customDates[0]),
          endDate: formatDateToMDY(customDates[1])
        };
      }
      // Fallback to last 30 days if custom dates not set
      startDate.setDate(today.getDate() - 30);
      break;
    default:
      startDate = new Date(today.getFullYear(), 0, 1); // Default to this year
  }

  return {
    startDate: formatDateToMDY(startDate),
    endDate: formatDateToMDY(endDate)
  };
};

// --- Minimal Loading Overlay Component ---
const MinimalLoadingOverlay: React.FC<{ isLoading: boolean }> = ({ isLoading }) => {
  if (!isLoading) return null;

  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        backdropFilter: 'blur(3px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000,
        borderRadius: 0, // Cover the entire dashboard area
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2,
          background: 'rgba(255, 255, 255, 0.95)',
          padding: 3,
          borderRadius: 3,
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
          border: '1px solid rgba(255, 255, 255, 0.8)',
          minWidth: 200,
        }}
      >
        <CircularProgress size={36} thickness={4} sx={{ color: '#2563eb' }} />
        <Typography 
          variant="body2" 
          sx={{ 
            color: '#64748b', 
            fontWeight: 500,
            fontSize: 14,
            textAlign: 'center'
          }}
        >
          Loading analytics data...
        </Typography>
      </Box>
    </Box>
  );
};

// --- Card Loading Skeleton Component ---
// const CardLoadingSkeleton: React.FC<{ height?: number }> = ({ height = 60 }) => (
//   <Box
//     sx={{
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center',
//       height: height,
//       background: 'linear-gradient(90deg, #f1f5f9 25%, #e2e8f0 50%, #f1f5f9 75%)',
//       backgroundSize: '200% 100%',
//       animation: 'shimmer 1.5s infinite',
//       borderRadius: 2,
//       '@keyframes shimmer': {
//         '0%': {
//           backgroundPosition: '-200% 0',
//         },
//         '100%': {
//           backgroundPosition: '200% 0',
//         },
//       },
//     }}
//   >
//     <CircularProgress size={20} thickness={4} sx={{ color: '#94a3b8' }} />
//   </Box>
// );

// --- Dashboard Component ---
export const AnalyticsDashboard: React.FC = () => {
  const { loading: accessLoading } = useAccess();
  const [dateRange, setDateRange] = useState("year");
  const [customDate, setCustomDate] = useState<[Date | null, Date | null]>([
    null,
    null,
  ]);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [tempStartDate, setTempStartDate] = useState<string>("");
  const [tempEndDate, setTempEndDate] = useState<string>("");

  // Calculate date range based on filter
  const { startDate, endDate } = getDateRangeForFilter(dateRange, customDate);

  // Analytics Dashboard Query
  const { data: analyticsData, loading: analyticsLoading, error: analyticsError } = useQuery(ANALYTICS_DASHBOARD, {
    variables: {
      input: {
        startDate,
        endDate
      }
    }
  });

  // Use real data from analytics query or show empty state
  const leadsVsUsersVsRevenueChart = analyticsData?.analyticsDashboard?.leadsVsUsersVsRevenueChart ? {
    labels: analyticsData.analyticsDashboard.leadsVsUsersVsRevenueChart.labels,
    datasets: analyticsData.analyticsDashboard.leadsVsUsersVsRevenueChart.datasets.map(dataset => ({
      label: dataset.label,
      data: dataset.data,
      borderColor: dataset.borderColor,
      backgroundColor: dataset.backgroundColor,
      fill: false,
      tension: dataset.tension || 0.4,
      pointRadius: dataset.pointRadius || 2,
      borderWidth: dataset.borderWidth || 2,
      yAxisID: dataset.yAxisID || undefined
    })).filter(dataset => dataset.data && dataset.data.length > 0)
  } : null;

  const hasChartData = leadsVsUsersVsRevenueChart && leadsVsUsersVsRevenueChart.datasets.length > 0;

  // Show full page loader only for access loading, use minimal overlay for analytics loading
  if (accessLoading) {
    return <AppLoader isLoading={accessLoading} />;
  }

  return (
    <Box sx={dashboardContainerStyle}>
      <Container sx={{ px: 0, position: 'relative' }}>
        <div
          className="flex"
          style={{ width: "100%", justifyContent: "flex-end" }}
        >
          <Box style={filterBarStyle}>
            <FormControl size="small" style={filterControlStyle}>
              <InputLabel>Date Range</InputLabel>
              <Select
                value={dateRange}
                label="Date Range"
                onChange={(e) => {
                  const newValue = e.target.value;
                  setDateRange(newValue);
                  // Clear custom dates when selecting a predefined range
                  if (newValue !== "custom") {
                    setCustomDate([null, null]);
                    setShowDatePicker(false); // Also close date picker if open
                  }
                }}
                sx={{ fontSize: 14 }}
              >
                {dashboardData.filters.dateRanges.map((opt) => (
                  <MenuItem key={opt.value} value={opt.value}>
                    {opt.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {/* Custom Date Picker Button */}
            <IconButton
              size="small"
              sx={{
                ml: 1,
                border: "1px solid #e5e7eb",
                borderRadius: 2,
                background: "#fff",
              }}
              onClick={() => {
                // Initialize temp dates with current custom dates or today
                const today = new Date();
                setTempStartDate(customDate[0] ? customDate[0].toISOString().split('T')[0] : today.toISOString().split('T')[0]);
                setTempEndDate(customDate[1] ? customDate[1].toISOString().split('T')[0] : today.toISOString().split('T')[0]);
                setShowDatePicker(true);
              }}
            >
              <CalendarTodayIcon fontSize="small" />
            </IconButton>
            {/* Show selected date range as Chip */}
            {customDate[0] && customDate[1] && (
              <Chip
                label={`${customDate[0].toLocaleDateString()} - ${customDate[1].toLocaleDateString()}`}
                size="small"
                sx={{ ml: 1, background: "#f1f5f9", fontWeight: 500 }}
                onDelete={() => {
                  setCustomDate([null, null]);
                  setDateRange("year");
                }}
              />
            )}
            {/* Show selected date range from dropdown if not custom */}
            {dateRange !== "custom" && (
              <Chip
                label={
                  dashboardData.filters.dateRanges.find(
                    (r) => r.value === dateRange
                  )?.label
                }
                size="small"
                sx={{ ml: 1, background: "#f1f5f9", fontWeight: 500 }}
              />
            )}
          </Box>
        </div>

        {/* Inline Custom Date Picker - Floating Overlay */}
        {showDatePicker && (
          <>
            {/* Subtle backdrop */}
            <Box
              sx={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.02)',
                backdropFilter: 'blur(1px)',
                zIndex: 1000,
              }}
            />
            <ClickAwayListener onClickAway={() => setShowDatePicker(false)}>
              <Box
                sx={{
                  position: 'absolute',
                  top: 70, // Just below the filter bar
                  right: 24,
                  zIndex: 1001,
                  p: 3,
                  background: "#fff",
                  border: "1px solid #e5e7eb",
                  borderRadius: 3,
                  boxShadow: "0 12px 40px rgba(0, 0, 0, 0.15)",
                  maxWidth: 400,
                  minWidth: 350,
                  animation: 'slideDown 0.2s ease-out',
                  '@keyframes slideDown': {
                    '0%': {
                      opacity: 0,
                      transform: 'translateY(-10px)',
                    },
                    '100%': {
                      opacity: 1,
                      transform: 'translateY(0)',
                    },
                  },
                }}
              >
            <Typography fontWeight={600} fontSize={16} mb={2} color="#22223b">
              Select Custom Date Range
            </Typography>
            
            {/* Quick preset options */}
            <Box sx={{ display: 'flex', gap: 1, mb: 2, flexWrap: 'wrap' }}>
              {[
                { label: 'Last 90 days', days: 90 },
                { label: 'Last 6 months', days: 180 },
                { label: 'Last year', days: 365 },
              ].map((preset) => (
                <Chip
                  key={preset.label}
                  label={preset.label}
                  size="small"
                  clickable
                  onClick={() => {
                    const today = new Date();
                    const startDate = new Date(today);
                    startDate.setDate(today.getDate() - preset.days);
                    setTempStartDate(startDate.toISOString().split('T')[0]);
                    setTempEndDate(today.toISOString().split('T')[0]);
                  }}
                  sx={{
                    backgroundColor: '#f8fafc',
                    color: '#64748b',
                    fontSize: 12,
                    '&:hover': {
                      backgroundColor: '#e2e8f0',
                    }
                  }}
                />
              ))}
            </Box>

            <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
              <TextField
                label="Start Date"
                type="date"
                size="small"
                value={tempStartDate}
                onChange={(e) => setTempStartDate(e.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
                sx={{ flex: 1 }}
              />
              <TextField
                label="End Date"
                type="date"
                size="small"
                value={tempEndDate}
                onChange={(e) => setTempEndDate(e.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
                sx={{ flex: 1 }}
              />
            </Box>
            <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end' }}>
              <Button 
                size="small" 
                onClick={() => setShowDatePicker(false)}
                sx={{ color: '#64748b' }}
              >
                Cancel
              </Button>
              <Button 
                size="small"
                variant="contained"
                onClick={() => {
                  if (tempStartDate && tempEndDate) {
                    const startDate = new Date(tempStartDate);
                    const endDate = new Date(tempEndDate);
                    
                    if (startDate <= endDate) {
                      setCustomDate([startDate, endDate]);
                      setDateRange("custom");
                      setShowDatePicker(false);
                    } else {
                      alert("Start date must be before end date");
                    }
                  } else {
                    alert("Please select both start and end dates");
                  }
                }}
                sx={{ 
                  background: '#2563eb',
                  '&:hover': { background: '#1d4ed8' }
                }}
              >
                Apply
              </Button>
            </Box>
            </Box>
          </ClickAwayListener>
          </>
        )}        {/* Charts Section with Loading Overlay */}
        <Box sx={{ position: 'relative', mt: 3 }}>
          {/* Minimal Loading Overlay - Only covers charts */}
          <MinimalLoadingOverlay isLoading={analyticsLoading} />
          
          {/* Charts content with opacity control */}
          <Box sx={{ opacity: analyticsLoading ? 0.6 : 1, transition: 'opacity 0.3s ease' }}>
            {/* Dashboard Layout */}
            <Grid container spacing={2} alignItems="stretch">
          {/* Row 1 */}
          <Grid item xs={12} md={6}>
            {/* Column 1: Leads by Time Period */}
            <Card style={cardStyle}>
              <Typography fontWeight={600} fontSize={18} mb={1}>
                Leads by Time Period
              </Typography>
              {/* Responsive Metrics Bar */}
              <Grid container spacing={2} mb={2} mt={1}>
                <Grid item xs={12} sm={4}>
                  <Box
                    sx={{
                      background: "#f1f5f9",
                      borderRadius: 2,
                      px: 2,
                      py: 1,
                      minWidth: 0,
                      textAlign: "center",
                    }}
                  >
                    <Typography fontWeight={700} fontSize={20} color="#2563eb">
                      {analyticsData?.analyticsDashboard?.leadsVsUsersVsRevenueChart?.leadTotal || 0}
                    </Typography>
                    <Typography fontSize={13} color="#64748b">
                      Leads
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Box
                    sx={{
                      background: "#f1f5f9",
                      borderRadius: 2,
                      px: 2,
                      py: 1,
                      minWidth: 0,
                      textAlign: "center",
                    }}
                  >
                    <Typography fontWeight={700} fontSize={20} color="#22c55e">
                      {analyticsData?.analyticsDashboard?.leadsVsUsersVsRevenueChart?.activeUserTotal || 0}
                    </Typography>
                    <Typography fontSize={13} color="#64748b">
                      Active Users
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Box
                    sx={{
                      background: "#f1f5f9",
                      borderRadius: 2,
                      px: 2,
                      py: 1,
                      minWidth: 0,
                      textAlign: "center",
                    }}
                  >
                    <Typography fontWeight={700} fontSize={20} color="#fbbf24">
                      $
                      {analyticsData?.analyticsDashboard?.leadsVsUsersVsRevenueChart?.revenueTotal?.toLocaleString() || 0}
                    </Typography>
                    <Typography fontSize={13} color="#64748b">
                      Revenue
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
              {/* Multi-line Chart (larger, improved design) */}
              <Box
                mt={2}
                mb={2}
                sx={{ px: { xs: 0, md: 2 }, height: { xs: 240, md: 320 } }}
              >
                {hasChartData ? (
                  <Line
                    data={leadsVsUsersVsRevenueChart}
                    options={{
                      plugins: {
                        legend: {
                          display: true,
                          position: "bottom",
                          labels: {
                            font: { size: 13 },
                            color: "#64748b",
                            boxWidth: 16,
                          },
                        },
                        tooltip: {
                          mode: "index",
                          intersect: false,
                        },
                      },
                      scales: {
                        x: {
                          grid: { color: "#f1f5f9" },
                          ticks: { color: "#64748b" },
                        },
                        y: {
                          grid: { color: "#f1f5f9" },
                          ticks: { color: "#64748b" },
                          beginAtZero: true,
                          title: { display: true, text: "Count" },
                        },
                        y1: {
                          position: "right",
                          grid: { drawOnChartArea: false },
                          ticks: { color: "#fbbf24" },
                          title: { display: true, text: "Revenue ($)" },
                        },
                      },
                      responsive: true,
                      maintainAspectRatio: false,
                    }}
                    height={320}
                  />
                ) : (
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    height="100%"
                    flexDirection="column"
                    sx={{ color: "#64748b" }}
                  >
                    <Typography variant="h6" color="inherit" mb={1}>
                      No Data Available
                    </Typography>
                    <Typography variant="body2" color="inherit" textAlign="center">
                      Chart data will appear here once analytics data is loaded
                    </Typography>
                  </Box>
                )}
              </Box>
            </Card>
          </Grid>
          <Grid item xs={12} md={6}>
            {/* Column 2: Nested Grid */}
            <Grid
              container
              direction={"row"}
              spacing={2}
              sx={{ height: "100%" }}
            >
              {/* Row 1: Revenue (Construction) + Revenue (Completed) */}
              <Grid item xs={12} md={6}>
                <Card style={cardStyle}>
                  <Typography fontWeight={600} fontSize={18} mb={1}>
                    Revenue (Construction)
                  </Typography>
                  <Box display="flex" alignItems="center" gap={1}>
                    <Typography style={metricValueStyle}>
                      $
                      {analyticsData?.analyticsDashboard?.revenues?.find(r => r.label === "revenueConstruction")?.total?.toLocaleString() || 0}
                    </Typography>
                    <Chip
                      size="small"
                      label={
                        <span
                          style={{
                            color:
                              (analyticsData?.analyticsDashboard?.revenues?.find(r => r.label === "revenueConstruction")?.change || 0) > 0
                                ? "#22c55e"
                                : "#ef4444",
                          }}
                        >
                          {(analyticsData?.analyticsDashboard?.revenues?.find(r => r.label === "revenueConstruction")?.change || 0) > 0
                            ? "▲"
                            : "▼"}{" "}
                          {Math.abs(analyticsData?.analyticsDashboard?.revenues?.find(r => r.label === "revenueConstruction")?.change || 0)}%
                        </span>
                      }
                      style={{
                        background:
                          (analyticsData?.analyticsDashboard?.revenues?.find(r => r.label === "revenueConstruction")?.change || 0) > 0
                            ? "#e6f9f0"
                            : "#fef2f2",
                        color:
                          (analyticsData?.analyticsDashboard?.revenues?.find(r => r.label === "revenueConstruction")?.change || 0) > 0
                            ? "#22c55e"
                            : "#ef4444",
                        fontWeight: 500,
                      }}
                    />
                  </Box>
                  <Typography style={metricSubStyle} mb={2}>
                    This Period
                  </Typography>
                  {analyticsData?.analyticsDashboard?.revenues?.find(r => r.label === "revenueConstruction")?.sparkLine ? (
                    <Line
                      data={{
                        labels: analyticsData.analyticsDashboard.revenues.find(r => r.label === "revenueConstruction")?.labels || [],
                        datasets: [
                          {
                            label: "Trend",
                            data: analyticsData.analyticsDashboard.revenues.find(r => r.label === "revenueConstruction")?.sparkLine || [],
                            borderColor: "#fbbf24",
                            backgroundColor: "rgba(251,191,36,0.1)",
                            fill: true,
                            tension: 0.4,
                          },
                        ],
                      }}
                      options={{
                        plugins: { legend: { display: false } },
                        scales: {
                          x: { display: false },
                          y: { display: false },
                        },
                      }}
                      height={60}
                    />
                  ) : (
                    <Box
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      height={60}
                      sx={{ color: "#64748b" }}
                    >
                      <Typography variant="body2" color="inherit">
                        No trend data available
                      </Typography>
                    </Box>
                  )}
                </Card>
              </Grid>
              <Grid item xs={12} md={6}>
                <Card style={cardStyle}>
                  <Typography fontWeight={600} fontSize={18} mb={1}>
                    Revenue (Completed)
                  </Typography>
                  <Box display="flex" alignItems="center" gap={1}>
                    <Typography style={metricValueStyle}>
                      $
                      {analyticsData?.analyticsDashboard?.revenues?.find(r => r.label === "revenueCompled")?.total?.toLocaleString() || 0}
                    </Typography>
                    <Chip
                      size="small"
                      label={
                        <span
                          style={{
                            color:
                              (analyticsData?.analyticsDashboard?.revenues?.find(r => r.label === "revenueCompled")?.change || 0) > 0
                                ? "#22c55e"
                                : "#ef4444",
                          }}
                        >
                          {(analyticsData?.analyticsDashboard?.revenues?.find(r => r.label === "revenueCompled")?.change || 0) > 0
                            ? "▲"
                            : "▼"}{" "}
                          {Math.abs(analyticsData?.analyticsDashboard?.revenues?.find(r => r.label === "revenueCompled")?.change || 0)}%
                        </span>
                      }
                      style={{
                        background:
                          (analyticsData?.analyticsDashboard?.revenues?.find(r => r.label === "revenueCompled")?.change || 0) > 0
                            ? "#e6f9f0"
                            : "#fef2f2",
                        color:
                          (analyticsData?.analyticsDashboard?.revenues?.find(r => r.label === "revenueCompled")?.change || 0) > 0
                            ? "#22c55e"
                            : "#ef4444",
                        fontWeight: 500,
                      }}
                    />
                  </Box>
                  <Typography style={metricSubStyle} mb={2}>
                    This Period
                  </Typography>
                  {analyticsData?.analyticsDashboard?.revenues?.find(r => r.label === "revenueCompled")?.sparkLine ? (
                    <Line
                      data={{
                        labels: analyticsData.analyticsDashboard.revenues.find(r => r.label === "revenueCompled")?.labels || [],
                        datasets: [
                          {
                            label: "Trend",
                            data: analyticsData.analyticsDashboard.revenues.find(r => r.label === "revenueCompled")?.sparkLine || [],
                            borderColor: "#22c55e",
                            backgroundColor: "rgba(34,197,94,0.1)",
                            fill: true,
                            tension: 0.4,
                          },
                        ],
                      }}
                      options={{
                        plugins: { legend: { display: false } },
                        scales: {
                          x: { display: false },
                          y: { display: false },
                        },
                      }}
                      height={60}
                    />
                  ) : (
                    <Box
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      height={60}
                      sx={{ color: "#64748b" }}
                    >
                      <Typography variant="body2" color="inherit">
                        No trend data available
                      </Typography>
                    </Box>
                  )}
                </Card>
              </Grid>
              <Grid item xs={12} md={6}>
                <Card
                  style={{
                    ...cardStyle,
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Typography
                    fontWeight={700}
                    fontSize={22}
                    mb={1}
                    align="center"
                  >
                    Amount Paid
                  </Typography>
                  <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Typography
                      style={{
                        ...metricValueStyle,
                        fontSize: 32,
                        marginBottom: 0,
                      }}
                    >
                      ${analyticsData?.analyticsDashboard?.amountPaid?.total?.toLocaleString() || 0}
                    </Typography>
                    <Typography
                      style={{
                        ...metricSubStyle,
                        fontSize: 16,
                        marginBottom: 8,
                      }}
                    >
                      Total Paid
                    </Typography>
                    <Box width={100} height={100} mb={1}>
                      {analyticsData?.analyticsDashboard?.amountPaid?.chart ? (
                        <Doughnut
                          data={analyticsData.analyticsDashboard.amountPaid.chart}
                          options={{
                            cutout: "75%",
                            plugins: { legend: { display: false } },
                          }}
                        />
                      ) : (
                        <Box
                          display="flex"
                          alignItems="center"
                          justifyContent="center"
                          width={100}
                          height={100}
                          sx={{ 
                            border: "2px solid #f1f5f9", 
                            borderRadius: "50%",
                            color: "#64748b" 
                          }}
                        >
                          <Typography variant="body2" color="inherit" fontSize={10}>
                            No Data
                          </Typography>
                        </Box>
                      )}
                    </Box>
                    <Typography
                      fontSize={16}
                      fontWeight={600}
                      color="#2563eb"
                      align="center"
                    >
                      {analyticsData?.analyticsDashboard?.amountPaid?.percent?.toFixed(2) || 0}% Collected
                    </Typography>
                  </Box>
                </Card>
              </Grid>
              <Grid item xs={12} md={6}>
                <Card
                  style={{
                    ...cardStyle,
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Typography
                    fontWeight={700}
                    fontSize={22}
                    mb={1}
                    align="center"
                  >
                    Project Status
                  </Typography>
                  <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Box width={100} height={100} mb={1}>
                      {analyticsData?.analyticsDashboard?.projectByProgress ? (
                        <Doughnut
                          data={{
                            labels: analyticsData.analyticsDashboard.projectByProgress.map((p) => p.label),
                            datasets: [
                              {
                                data: analyticsData.analyticsDashboard.projectByProgress.map((p) => p.value),
                                backgroundColor: analyticsData.analyticsDashboard.projectByProgress.map((p) => p.color),
                                borderWidth: 0,
                              },
                            ],
                          }}
                          options={{
                            cutout: "75%",
                            plugins: { legend: { display: false } },
                          }}
                        />
                      ) : (
                        <Box
                          display="flex"
                          alignItems="center"
                          justifyContent="center"
                          width={100}
                          height={100}
                          sx={{ 
                            border: "2px solid #f1f5f9", 
                            borderRadius: "50%",
                            color: "#64748b" 
                          }}
                        >
                          <Typography variant="body2" color="inherit" fontSize={10}>
                            No Data
                          </Typography>
                        </Box>
                      )}
                    </Box>
                    <Typography fontSize={28} fontWeight={700} align="center">
                      {analyticsData?.analyticsDashboard?.totalProjects || 0}
                    </Typography>
                    <Typography
                      color="#64748b"
                      fontSize={16}
                      align="center"
                      mb={2}
                    >
                      Total Projects
                    </Typography>
                    <Box
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      flexWrap="wrap"
                      gap={1}
                      sx={{ width: "100%" }}
                    >
                      {analyticsData?.analyticsDashboard?.projectByProgress ? 
                        analyticsData.analyticsDashboard.projectByProgress.map((s) => (
                          <Box key={s.label} display="flex" alignItems="center">
                            <span
                              style={{
                                display: "inline-block",
                                width: 10,
                                height: 10,
                                borderRadius: "50%",
                                background: s.color,
                                marginRight: 8,
                                verticalAlign: "middle",
                              }}
                            />
                            <Typography
                              color="#64748b"
                              fontWeight={500}
                              fontSize={11}
                            >
                              {s.label} ({s.value})
                            </Typography>
                          </Box>
                        )) : (
                          <Typography
                            color="#64748b"
                            fontSize={12}
                            align="center"
                          >
                            No project status data available
                          </Typography>
                        )
                      }
                    </Box>
                  </Box>
                </Card>
              </Grid>
            </Grid>
          </Grid>

          {/* Row 2 */}
          <Grid item xs={12} md={6}>
            {/* Column 1: Completed Projects */}
            <Card style={cardStyle}>
              <Typography fontWeight={600} fontSize={18} mb={1}>
                Completed Projects
              </Typography>
              <Typography style={metricValueStyle}>
                {analyticsData?.analyticsDashboard?.completedProjects?.total || 0}
              </Typography>
              <Typography style={metricSubStyle} mb={2}>
                Total Completed
              </Typography>
              {analyticsData?.analyticsDashboard?.completedProjects?.chart ? (
                <Bar
                  data={analyticsData.analyticsDashboard.completedProjects.chart}
                  options={{
                    plugins: { legend: { display: false } },
                    scales: {
                      x: {
                        grid: { color: "#f1f5f9" },
                        ticks: { color: "#64748b" },
                      },
                      y: {
                        grid: { color: "#f1f5f9" },
                        ticks: { color: "#64748b" },
                        beginAtZero: true,
                      },
                    },
                  }}
                  height={80}
                />
              ) : (
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  height={80}
                  sx={{ 
                    border: "1px solid #f1f5f9", 
                    borderRadius: 2,
                    color: "#64748b" 
                  }}
                >
                  <Typography variant="body2" color="inherit">
                    No chart data available
                  </Typography>
                </Box>
              )}
            </Card>
          </Grid>
          <Grid item xs={12} md={6}>
            {/* Column 2: Projects by Marketing Rep */}
            <Card style={cardStyle}>
              <Typography fontWeight={600} fontSize={18} mb={1}>
                Projects by Marketing Rep
              </Typography>
              {analyticsData?.analyticsDashboard?.projectsByRep?.chart ? (
                <Bar
                  data={analyticsData.analyticsDashboard.projectsByRep.chart}
                  options={{
                    indexAxis: "y" as const,
                    plugins: { legend: { display: false } },
                    scales: {
                      x: {
                        grid: { color: "#f1f5f9" },
                        ticks: { color: "#64748b" },
                        beginAtZero: true,
                      },
                      y: {
                        grid: { color: "#f1f5f9" },
                        ticks: { 
                          color: "#64748b",
                          maxTicksLimit: 10,
                          callback: function(value, index) {
                            const label = this.getLabelForValue(value as number);
                            return label && label.length > 15 ? label.substring(0, 15) + '...' : label;
                          }
                        },
                      },
                    },
                  }}
                  height={120}
                />
              ) : (
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  height={120}
                  sx={{ 
                    border: "1px solid #f1f5f9", 
                    borderRadius: 2,
                    color: "#64748b" 
                  }}
                >
                  <Typography variant="body2" color="inherit">
                    No rep data available
                  </Typography>
                </Box>
              )}
            </Card>
          </Grid>
          {/* Move Combined Bar + Line Chart to bottom */}
          {/* <Grid item xs={12}>
            <Grid container spacing={0} mb={2} sx={{ background: "#fff", borderRadius: 3 }}>
              {dashboardTopMetrics.map((metric, idx) => (
                <Grid item xs={12} sm={4} md={4} key={metric.label}>
                  <Box
                    sx={{
                      py: 2,
                      px: 0,
                      textAlign: "center",
                      borderRight:
                        idx < dashboardTopMetrics.length - 1
                          ? "1px solid #f1f5f9"
                          : "none",
                      borderBottom: {
                        xs:
                          idx < dashboardTopMetrics.length - 1
                            ? "1px solid #f1f5f9"
                            : "none",
                        sm: "none",
                      },
                    }}
                  >
                    <Typography
                      fontWeight={700}
                      fontSize={22}
                      color={metric.color}
                    >
                      {metric.value}
                    </Typography>
                    <Typography fontSize={15} color="#64748b">
                      {metric.label}
                    </Typography>
                  </Box>
                </Grid>
              ))}
            </Grid>
            <Box
              sx={{
                width: "100%",
                height: { xs: 260, md: 320 },
                background: "#fff",
                borderRadius: 3,
                px: 2,
                py: 2,
                mt: 2,
              }}
            >
              <Chart
                type="bar"
                data={projectsChartData}
                options={{
                  plugins: {
                    legend: {
                      display: true,
                      position: "bottom",
                      labels: {
                        font: { size: 13 },
                        color: "#64748b",
                        boxWidth: 16,
                        usePointStyle: true,
                      },
                    },
                    tooltip: {
                      mode: "index",
                      intersect: false,
                      callbacks: {
                        label: function (context) {
                          if (context.dataset.label === "Revenue") {
                            return `Revenue: $${(
                              context.parsed.y / 1000
                            ).toFixed(2)}k`;
                          }
                          return `${context.dataset.label}: ${context.parsed.y}`;
                        },
                      },
                    },
                  },
                  scales: {
                    x: {
                      grid: { color: "#f1f5f9" },
                      ticks: { color: "#64748b" },
                    },
                    y: {
                      grid: { color: "#f1f5f9" },
                      ticks: { color: "#64748b" },
                      beginAtZero: true,
                      title: { display: false },
                    },
                    y1: {
                      position: "right",
                      grid: { drawOnChartArea: false },
                      ticks: { color: "#fbbf24" },
                      title: { display: false },
                    },
                  },
                  responsive: true,
                  maintainAspectRatio: false,
                }}
                height={320}
              />
            </Box>
          </Grid> */}
        </Grid>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};
